import { createAsyncThunk } from '@reduxjs/toolkit';
import { getQuote, emailQuote } from 'shared/api/apiQuote';
import { selectAssemblyDataForQuote } from 'shared/product_tabs/tab_assembly/slice/selectors';

export const doQuote = createAsyncThunk(
  'assembly/doQuote',
  async (_args, thunkAPI) => {
    const state = thunkAPI.getState();
    const { variant, parameters, suppliers } = selectAssemblyDataForQuote(state);

    const token = document.getElementsByName('authenticity_token')[0].value;
    const data = {};

    suppliers.forEach((s) => {
      data[s] = parameters;
    });

    const promise = getQuote({
      data,
      token,
      variant,
      quoteNumber: parameters.product_quote_number,
    });

    return promise
      .then((res) => res.data)
      .catch((error) => thunkAPI.rejectWithValue({ error: error.message }));
  },
);

export const doEmailQuote = createAsyncThunk(
  'assembly/doEmailQuote',
  async (args, thunkAPI) => {
    const token = document.getElementsByName('authenticity_token')[0].value;
    const { data } = args;

    const promise = emailQuote({ data, token });

    return promise
      .then((res) => res.data)
      .catch((error) => thunkAPI.rejectWithValue({ error: error.message }));
  },
);
